<div class="modal-header">
    <h5 class="modal-title">Yeni Not Ekle</h5>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body mb-3">
    <form [formGroup]="noteForm">
        <div class="row">
            <!-- Başlık -->
            <div class="col-12">
                <label class="form-label">Başlık</label>
                <ng-select formControlName="categoryId" [items]="categories" bindLabel="categoryName" bindValue="id"
                    placeholder="Başlık seçiniz">
                    <ng-template ng-header-tmp
                        *ngIf="authService.isEndpointStatus('PUT.Updateing.UpdateNote') || authService.isEndpointStatus('POST.Writing.CreateNote')">
                        <button
                            class="add-new-customer btn btn-flat-success cursor-pointer rounded-0 text-left p-50 w-100"
                            (click)="showCreateCategoryDialog(); select.blur(); select.close()">
                            <i data-feather="plus"></i>
                            <span class="align-middle ml-25">Yeni Kategori Ekle</span>
                        </button>
                    </ng-template>
                </ng-select>
                <div *ngIf="noteForm.get('categoryId')?.touched && noteForm.get('categoryId')?.invalid"
                    class="text-danger small mt-1">
                    Başlık zorunludur
                </div>
            </div>

            <!-- Tarih -->
            <!-- Tarih -->
            <div class="col-6">
                <label class="form-label">Tarih</label>
                <ng2-flatpickr formControlName="createdAt" [config]="dateTimeOptions" [setDate]="date">
                </ng2-flatpickr>
                <div *ngIf="noteForm.get('createdAt')?.touched && noteForm.get('createdAt')?.invalid"
                    class="text-danger small mt-1">
                    Tarih seçilmelidir.
                </div>
            </div>


            <!-- Gönderen -->
            <!-- <div class="col-md-6 col-sm-12">
                <label class="form-label">Yazan Kişi</label>
                <ng-select formControlName="personSenderId" [items]="personSenders" bindLabel="fullName" bindValue="id"
                    placeholder="Gönderen kişiyi seçiniz" (search)="getAllPersonSenders($event)">
                </ng-select>
            </div> -->

            <!-- Alıcı -->
            <div class="col-md-6 col-sm-12">
                <label class="form-label">İlgili Personel</label>
                <ng-select formControlName="personRecevierId" [items]="personReceviers" bindLabel="fullName"
                    bindValue="id" placeholder="Alıcı kişiyi seçiniz" (search)="getAllPersonReceviers()">
                </ng-select>
            </div>

            <!-- Açıklama -->
            <div class="col-12 mb-5">
                <label class="form-label">Açıklama</label>
                <quill-editor formControlName="description" [modules]="{
              toolbar: [
                ['bold', 'italic', 'underline'],
                [{ list: 'ordered' }, { list: 'bullet' }],
                ['link', 'clean']
              ]
            }" placeholder="Not açıklamasını giriniz...">
                </quill-editor>
                <div *ngIf="noteForm.get('description')?.touched && noteForm.get('description')?.invalid"
                    class="text-danger small mt-1">
                    Açıklama en az 3 karakter olmalıdır.
                </div>
            </div>
        </div>
    </form>
</div>

<div class="modal-footer mt-2">
    <button type="button" class="btn btn-outline-secondary" (click)="closeModal(false)">İptal</button>

    <button type="button" class="btn btn-primary" [disabled]="noteForm.invalid" (click)="onSubmit()"
        *ngIf="authService.isEndpointStatus('PUT.Updateing.UpdateNote') && id != null">
        Güncelle
    </button>

    <button type="button" class="btn btn-primary" [disabled]="noteForm.invalid" (click)="onSubmit()"
        *ngIf="authService.isEndpointStatus('POST.Writing.CreateNote') && id == null">
        Kaydet
    </button>
</div>